module.exports = __webpack_public_path__ + "static/media/plastic-free-wedding.649fd504.webp";